import { Employee, Page, TicketRight, TicketRightHolder } from './api-clients/api-types'

export enum ModalState {
  CLOSED,
  DELETE,
  EDIT,
}

export enum EditState {
  EMPLOYMENT,
  DISPLAY,
  COMPANY,
}

export type SearchHistory = {
  searchResult: Page<TicketRightHolder>
  query: string
  page: number
  perPage: number
}

export type HistoryState = {
  search?: SearchHistory
  employee?: Employee
  newIndex?: number
  resetSearch?: boolean
}

export type TicketRightWithDraft = {
  id: number
  ticketRight: TicketRight
  draft: TicketRight | undefined
}
